

const resetScrollPosition = (behavior = "auto") => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth"})
}

const reloadWindow = () => {
    window.location.reload()
}
export default { resetScrollPosition, reloadWindow }